import styled from 'styled-components'

export const StyledSvg = styled.svg<{ hoverColor: string }>`
  &:hover {
    & path {
      stroke: ${({ hoverColor }) => hoverColor};
    }
  }
`
